export const apiUrl = process.env.REACT_APP_API_URL;
export const apiPublicUrl = process.env.REACT_APP_API_PUBLIC_URL;
export const apiSecret = process.env.REACT_APP_API_SECRET;
